module.exports.config = {
  "declarative": true,

  "render-module": {
    "name": "PieceNewsletterRenderModule",
    "path": "front/piece-newsletter-render.module"
  },

  "definition": {
    "type": "newsletter",
    "name": "PieceNewsletterDefinition",
    "group": "Forms",
    "availablePlatforms": ["web"],
    "description": "Newsletter",

    "fields": [
      { "name": "placeholder", "label": "Texto del placeholder", "placeholder": "Texto del placeholder", "type": "plainText", "mandatory": true },
      {
        "name": "showCustomEmailError",
        "label": "Personalizar mensaje de email inválido",
        "type": "groupToggleable",
        "flattenFields": true,
        "fields": [
          {
            "name": "customEmailError",
            "label": "Mensaje en caso de email inválido",
            "placeholder": "Email incorrecto",
            "type": "plainText",
            "mandatory": true
          }
        ]
      },
      {
        "name": "showSubscriptionErrorMessage",
        "label": "Personalizar mensaje de error al suscribirse",
        "type": "groupToggleable",
        "flattenFields": true,
        "fields": [
          {
            "name": "subscriptionErrorMessage",
            "label": "Mensaje en caso de error al suscribirse",
            "placeholder": "Se ha producido un error, inténtalo de nuevo",
            "type": "plainText",
            "mandatory": false
          },
        ]
      },
      {
        "name": "showTitle",
        "label": "Título",
        "type": "groupToggleable",
        "flattenFields": true,
        "fields": [{
          "includePaddingSelector": true,
          "name": "titleText",
          "label": "Texto de título",
          "type": "richTextByDevice"
        }]
      },
      {
        "name": "showSubtitle",
        "label": "Entradilla",
        "type": "groupToggleable",
        "flattenFields": true,
        "fields": [{
          "includePaddingSelector": true,
          "name": "subtitleText",
          "label": "Texto de entradilla",
          "type": "richTextByDevice"
        }]
      },
      {
        "name": "formCollapse",
        "label": "contraer formulario",
        "type": "groupToggleable",
        "flattenFields": false,
        "fields": []
      },
      {
        "type": "groupCollapsable",
        "name": "placeholderStyles",
        "label": "Estilos de los campos",
        "fields": [
          { "name": "inputPlaceholderColor", "label": "Color del placeholder", "type": "color", "defaultValue": "#000" },
          { "name": "inputTextSize", "label": "Tamaño del texto", "type": "units", "defaultValue": "16px" },
          { "name": "inputTextColor", "label": "Color del texto input", "type": "color", "defaultValue": "#000" },
          { "name": "inputBgColor", "label": "Color de fondo input", "type": "color", "defaultValue": "" },
          { "name": "placeholderPadding", "label": "Padding al input", "type": "linkedUnits" }
        ]
      },
      { "type": "groupCollapsable", "name": "buttonSubmitStyles", "label": "Botón", "fields": [
          { "name": "position", "label": "Posición", "type": "options", "defaultValue": "inline", "values": [
            { "value": "inline", "label": "En linea" },
            { "value": "block", "label": "En bloque" }
          ]},
          { "name": "type", "label": "Tipo", "type": "options", "defaultValue": "icon", "values": [
              { "value": "icon", "label": "Icono" },
              { "value": "text", "label": "Texto", "shouldDisplayWhenSelected": "text" }
          ]}
      ]},
      {
        "type": "groupCollapsable",
        "name": "categories",
        "label": "Categorías",
        "fields": [
          { "name": "displayCategoriesTitle", "label": "Mostrar título", "type": "groupToggleable", "flattenFields": true, "fields": [
              { "name": "titleText", "label": "Texto del título", "placeholder": "Escribe el texto", "type": "richTextByDevice", "mandatory": true, "includePaddingSelector": true, }
          ]},
          { "name": "linkedCategories", "label": "Elementos de categoría", "type": "linkedCategories" },
          { "name": "isRequired", "label": "Campo obligatorio", "type": "groupToggleable", "flattenFields": true, "fields": [
            { "name": "requiredMessage", "label": "Mensaje", "placeholder": "Mensaje", "type": "plainText", "mandatory": false }
          ]}
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "icons",
        "label": "Iconos",
        "flattenFields": true,
        "fields": [
          { "name": "customIconButton", "label": "Personalizado para botón", "placeholder": "Icono personalizado", "type": "icon", "mandatory": false },
          { "name": "customIconSuccess", "label": "Personalizado para email enviado", "placeholder": "Icono personalizado", "type": "icon", "mandatory": false },
          { "name": "customIconLoading", "label": "Personalizado mientras se envía el email", "placeholder": "Icono personalizado", "type": "icon", "mandatory": false },
          { "name": "customIconFailure", "label": "Personalizado para email inválido", "placeholder": "Icono personalizado", "type": "icon", "mandatory": false }
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "legalTextStyles",
        "label": "Texto legal",
        "flattenFields": true,
        "fields": [
          { "name": "text", "label": "Texto legal", "placeholder": "Texto legal", "type": "richText", "mandatory": true },
          { "name": "textPadding", "label": "Padding al texto legal", "type": "linkedUnits", "jsonPath": "styles.padding" },
          { "name": "legalErrorMessage", "label": "Mensaje de error", "type": "plainText", "jsonPath": "legalErrorMessage" },
          {
            "name": "legalTextClickEvent",
            "label": "Evento Click",
            "type": "groupToggleable",
            "flattenFields": false,
            "fields": []
          },
        ]
      },
      {
        "name": "birthdate",
        "label": "Fecha de nacimiento",
        "type": "groupCollapsable",
        "fields": [
          {
            "name": "titleBirthdate",
            "label": "Mostrar título",
            "type": "groupToggleable",
            "flattenFields": true,
            "fields": [
              {
                "name": "titleText",
                "label": "Texto título",
                "placeholder": "Escribe el texto",
                "type": "richTextByDevice",
                "includePaddingSelector": true,
                "mandatory": true
              }
            ]
          },
          {
            "name": "fieldsBirthdate",
            "label": "Campos de fecha",
            "type": "groupToggleable",
            "flattenFields": false,
            "fields": [
              {
                "name": "formatBirthdate",
                "label": "Formato",
                "type": "options",
                "defaultValue": "dayMonth",
                "values": [
                  { "value": "dayMonth", "label": "Día / Mes" },
                  { "value": "dayMonthYear", "label": "Día / Mes / Año", "shouldDisplayWhenSelected": "yearPlaceholder" }
                ]
              },
              {
                "name": "dayPlaceholder",
                "label": "Día",
                "placeholder": "Texto del placeholder",
                "type": "plainText",
                "mandatory": false
              },
              {
                "name": "monthPlaceholder",
                "label": "Mes",
                "placeholder": "Texto del placeholder",
                "type": "plainText",
                "mandatory": false
              }
            ]
          },
          {
            "name": "isRequired",
            "label": "Campo obligatorio",
            "type": "groupToggleable",
            "flattenFields": true,
            "fields": [
              {
                "name": "requiredMessage",
                "label": "Mensaje",
                "type": "plainText",
                "mandatory": false
              }
            ]
          }
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "links",
        "label": "Enlaces",
        "fields": [
          { "name": "legalConditions", "label": "Condiciones legales", "type": "groupToggleable", "fields": [
            { "name": "text", "label": "Texto", "placeholder": "Texto", "type": "plainText", "mandatory": true },
            { "name": "url", "label": "URL", "placeholder": "URL", "type": "plainText", "mandatory": true },
            {
              "name": "legalConditionsClickEvent",
              "label": "Evento Click",
              "type": "groupToggleable",
              "flattenFields": false,
              "fields": []
            }
          ]},
          { "name": "unsubscribe", "label": "Darse de baja", "type": "groupToggleable", "fields": [
            { "name": "text", "label": "Texto del botón", "placeholder": "Texto", "type": "plainText", "mandatory": true },
            { "name": "backText", "label": "Texto de volver atrás", "placeholder": "Texto", "type": "plainText", "mandatory": false },
            { "name": "padding", "label": "Padding del mensaje", "type": "linkedUnits", "mandatory": false },
            { "name": "successText", "label": "Mensaje de confirmación", "placeholder": "Escribe el texto", "type": "richText", "mandatory": true },
            { "name": "errorText", "label": "Mensaje de error", "placeholder": "Escribe el texto", "type": "richText", "mandatory": false },
            {
              "name": "showUnsubscribeTitle",
              "label": "Título",
              "type": "groupToggleable",
              "flattenFields": true,
              "fields": [{ "name": "unsubscribeTitle", "label": "Texto título", "type": "richTextByDevice", "includePaddingSelector": true }]
            },
            {
              "name": "showUnsubscribeSubtitle",
              "label": "Entradilla",
              "type": "groupToggleable",
              "flattenFields": true,
              "fields": [{ "name": "unsubscribeSubtitle", "label": "Texto entradilla", "type": "richTextByDevice", "includePaddingSelector": true },]
            },
          ]},
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "subscriptionConfirmation",
        "label": "Confirmación suscripción",
        "fields": [
          {
            "name": "showConfirmationScreen",
            "label": "Mostrar pantalla de confirmación",
            "type": "groupToggleable",
            "autoCollapse": true,
            "flattenFields": true,
            "fields": [
              {
                "name": "showConfirmationTitle",
                "label": "Título",
                "type": "groupToggleable",
                "flattenFields": true,
                "fields": [{
                  "includePaddingSelector": true,
                  "name": "confirmationTitle",
                  "label": "Texto título",
                  "type": "richTextByDevice"
                }]
              },
              {
                "name": "showConfirmationSubtitle",
                "label": "Entradilla",
                "type": "groupToggleable",
                "flattenFields": true,
                "fields": [{
                  "includePaddingSelector": true,
                  "name": "confirmationSubTitle",
                  "label": "Texto entradilla",
                  "type": "richTextByDevice"
                }]
              }
            ]
          },
        ]
      },
      { "name": "inputBoxColor", "label": "Color bordes formulario", "type": "color", "section": "styles" },
      {
        "type": "groupCollapsable",
        "name": "analytics",
        "label": "Analítica",
        "fields": [
          { "name": "id", "label": "Identificador", "placeholder": "Identificador", "type": "plainText", "mandatory": false },
          { "name": "description", "label": "Descripción", "placeholder": "Descripción", "type": "plainText", "mandatory": false },
          { "name": "value", "label": "Valor", "placeholder": "Valor", "type": "plainText", "mandatory": false }
        ]
      },
    ]
  }
};
